import React from "react";
import { connect } from "react-redux";

import { useIntl } from "react-intl";

import { Activity, EntityTypesSupportingRoutes } from "@mapmycustomers/shared/types/entity";
import { Alert } from "@mapmycustomers/ui";

import { RootState } from "@app/store/rootReducer";
import { MAX_ROUTE_STOPS } from "@app/util/consts";

import { getEntityType, getStops } from "../../store";
import { removeActivity } from "../../store/actions";

import styles from "./Adjust.module.scss";
import Stop from "./Stop";

interface Props {
  entityType: EntityTypesSupportingRoutes;
  removeActivity: (activity: Activity) => void;
  stops: Activity[];
}

const Stops: React.FC<Props> = ({ entityType, removeActivity, stops }) => {
  const intl = useIntl();

  return (
    <div>
      {stops.length > MAX_ROUTE_STOPS ? (
        <Alert
          className={styles.alert}
          message={intl.formatMessage({
            id: "activities.calendarView.routeBuilder.steps.adjust.alert.tooMany",
            defaultMessage: "Stop limit reached. Remove excess stops to build your route.",
            description:
              "Too many stops alert on Adjust step in Route Builder in Activities Calendar view",
          })}
          type="error"
        />
      ) : stops.length === 0 ? (
        <Alert
          className={styles.alert}
          message={intl.formatMessage({
            id: "activities.calendarView.routeBuilder.steps.adjust.alert.zeroStops",
            defaultMessage: "No stops selected from the given criteria",
            description:
              "Zero stops alert on Adjust step in Route Builder in Activities Calendar view",
          })}
          type="error"
        />
      ) : (
        <Alert
          className={styles.alert}
          message={intl.formatMessage({
            id: "activities.calendarView.routeBuilder.steps.adjust.alert.valid",
            defaultMessage:
              "You have selected a valid number of stops. Click “Next step” to proceed.",
            description:
              "Valid stops alert on Adjust step in Route Builder in Activities Calendar view",
          })}
          type="info"
        />
      )}
      <div>
        {stops.map((activity) => (
          <Stop
            activity={activity}
            entityType={entityType}
            key={activity.id}
            onRemove={removeActivity}
          />
        ))}
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  entityType: getEntityType(state),
  stops: getStops(state),
});

const mapDispatchToProps = {
  removeActivity,
};

export default connect(mapStateToProps, mapDispatchToProps)(Stops);
